import React from 'react';
import { RoutableLink } from 'apps/sigma2-ui/src/components/ui/RoutableLink';

export const Http404Page = () => {
  return (
    <div className="w-screen h-screen flex justify-center items-center text-black flex-col">
      <div className="font-bold text-9xl">404</div>
      <div className="text-4xl">Page Not Found</div>
      <RoutableLink className="underline mt-5" to="/">
        go back home
      </RoutableLink>
    </div>
  );
};
